
import { Step } from '@/backend/models/containers/step';
import { Status } from '@/types/containerTypes';
import { useTreeStore } from '../store/TreeStore';
import { ContainerTreeObject } from '../types/navigationTypes';

export function useGetFirstPendingStep() {
  const rootContainers = useTreeStore((state) => state.rootContainerNodes);

  const firstPendingStep = getFirstPendingStep(rootContainers);
  if (firstPendingStep) return firstPendingStep;

  return undefined;
}

const getFirstPendingStep = (parentContainers: ContainerTreeObject[]): ContainerTreeObject | undefined => {
  for (let i = 0; i < parentContainers.length; i += 1) {
    const container = parentContainers[i];
    if (container.container instanceof Step) {
      if (container.container.status === Status.PENDING) {
        return container;
      }
    }
    const firstPendingStep = getFirstPendingStep(container.children);
    if (firstPendingStep) return firstPendingStep;
  }
  return undefined;
};
